<template>
	<v-toolbar flat :color="headerColor" height="30px" style="z-index: 103; position: relative;">
		<v-toolbar-items v-if="$store.getters['chart/isEditable']">
			<v-btn flat color="white" class="pa-0 ma-0 btn-toggle-board-left-position">
				<v-icon v-if="isBoardLeftPosition">last_page</v-icon>
				<v-icon v-else>first_page</v-icon>
			</v-btn>
			<v-btn flat large color="white" class="pa-0 ma-0" @click="viewmode">視聴</v-btn>
			<v-btn flat :color="undoColor" class="pa-0 ma-0 caption" @click="undo" :class="undoClass">
				<v-icon>undo</v-icon>
			</v-btn>
			<v-btn flat :color="redoColor" class="pa-0 ma-0 caption" @click="redo" :class="redoClass">
				<v-icon>redo</v-icon>
			</v-btn>
		</v-toolbar-items>
		<v-toolbar-items v-else>
			<v-btn flat color="white" class="pa-0 ma-0 btn-toggle-board-left-position">
				<v-icon v-if="isBoardLeftPosition">last_page</v-icon>
				<v-icon v-else>first_page</v-icon>
			</v-btn>
			<v-btn flat large color="white" class="pa-0 ma-0" @click="editmode"
				v-if="canEdit">
					編集
			</v-btn>
			<v-btn flat large color="grey" class="pa-0 ma-0 disabled"
				v-else>
					編集
			</v-btn>
			<v-btn flat large color="white" class="pa-0 ma-0">印刷</v-btn>
		</v-toolbar-items>
		<v-spacer></v-spacer>
		<v-toolbar-items>
			<v-btn flat large color="white" @click="onClickMoveToToday">今日</v-btn>
			<v-layout hidden-sm-and-down>
				<v-divider class="ml-2 mr-4" inset vertical color="white"></v-divider>
				<v-btn-toggle v-model="toggleTick" mandatory class="transparent pr-2" style="height: 30px;">
					<v-btn v-for="term in TERMS" :key="term.id" :value="term.id"
						flat
						large
						class="white--text"
					>
						{{term.text}}
					</v-btn>
				</v-btn-toggle>
			</v-layout>
			<Menu />
		</v-toolbar-items>
		<template v-slot:extension>
			<v-toolbar flat color="primary" height="29px">
				<v-toolbar-items>
					<v-text-field
						v-model="filter_name"
						dark color="white"
						clearable
						height="24px"
						single-line
						placeholder="名前で検索"
						@input="onChangeFilterName"
					/>
					<v-btn flat large color="white">分類で絞る</v-btn>
				</v-toolbar-items>
			</v-toolbar>
		</template>
	</v-toolbar>
</template>

<script>
import Menu from '../Menu';

import { CHART_TICK } from '../../classes/Const';

export default {
	name: 'TCHeader',
	components: {
		Menu,
	},
	data(){
		return {
			TERMS : [
				{ id: CHART_TICK.SM.id, text: '小' },
				{ id: CHART_TICK.MD.id, text: '中' },
				{ id: CHART_TICK.BG.id, text: '大' },
			],
			toggleTick: CHART_TICK.MD.id,
			filter_name: '',
		}
	},
	methods: {
		editmode: function () {
			this.$store.commit('chart/setModeEdit');
		},
		viewmode: function () {
			this.$store.commit('chart/setModeView');
		},
		undo: function() {
			// TODO
		},
		redo: function() {
			// TODO
		},
		onClickMoveToToday() {
			this.$emit('move-to-today');
		},
		onChangeFilterName: function (){
			this.$emit("change-filter-name", this.filter_name);
		},
	},
	computed: {
		headerColor: function() {
			if (this.$store.getters['chart/isEditable'])
				return 'deep-orange';
			return 'primary';
		},
		undoColor: function() {
			// if (!this.$store.getters.canUndo)
				return 'deep-orange lighten-2';

			// return 'white';
		},
		undoClass: function() {
			let classes = new Array();

			// if (!this.$store.getters.canUndo)
				classes.push('disabled');

			return classes;
		},
		redoColor: function() {
			// if (!this.$store.getters.canRedo)
				return 'deep-orange lighten-2';

			// return 'white';
		},
		redoClass: function() {
			let classes = new Array();

			// if (!this.$store.getters.canRedo)
				classes.push('disabled');

			return classes;
		},
		canEdit: function() {
			return true;
		},
		isBoardLeftPosition() {
			return false;
		},
	},
	watch: {
		toggleTick: function(val) {
			this.$emit('change-chart-tick', Object.values(CHART_TICK).filter((item) => {
				return item.id === val;
			})[0]);
		},
	},
}
</script>
<style scoped>
	.disabled {
		pointer-events: none;
	}

	.btn-toggle-board-left-position {
		min-width: 24px;
	}
	
	.v-toolbar >>> .v-toolbar__extension {
		padding: 0px;
		border-top: dotted 1px #DFDFDF;
	}

	.v-input {
		padding-top: 0;
	}

	.theme--light.v-input input {
		color: white !important;
	}
</style>

